import { IEventLoggingComponentProps, withEventLogging } from '@AppModels/Logging';
import * as React from 'react';
import { AppState } from '../../../models/AppState';
import { IUserSessionContextConfig } from '../../../viewmodels/AppViewModels';
import { LevReactQueryDevtools } from '../../../web/ReactQueryDevtools';
import { ReactQueryProvider } from '../../../web/ReactQueryProvider';
import { SurveysRouter } from '../SurveysRouter';

interface IProps extends IEventLoggingComponentProps {
	userSessionConfig?: IUserSessionContextConfig;
}

interface IState {
	isLoading?: boolean;
}

class _SurveyApp extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		AppState.environment.appType = 'surveys';
		this.state = {
			isLoading: true,
		};
	}

	public componentDidMount() {
		this.setState({
			isLoading: false,
		});
	}

	public render() {
		return (
			<ReactQueryProvider>
				{this.state.isLoading ? <span style={{ display: 'none' }} /> : <SurveysRouter />}
				<LevReactQueryDevtools />
			</ReactQueryProvider>
		);
	}
}
export const SurveyApp = withEventLogging(_SurveyApp, 'SurveyApp');
